import React from "react";
import Radio from "ui/Radio/Radio";
import Price from "common/Price/Price";
import { cn } from "helpers/style";
import { gtm } from "helpers/analytics";
import { formatDate } from "helpers/date";
import { formattedMoney } from "helpers/money";
import { PRICES } from "constants/variables";
import styles from "./Prices.module.scss";

type Props = {
  prices: Array<Entity.Product.Price>;
  activePrice: Entity.Product.Price;
  onPriceChange: (price?: Entity.Product.Price) => void;
  isAvailable: boolean;
  pricePrefix?: string;
  showExpiryDate?: boolean;
  className?: string;
  product?: Entity.Product;
  classNamePrice?: string;
  classNamePriceCurrency?: string;
  // TODO: can be removed after solving the problem with the assembly of styles module.scss
  isNewPriceStyle?: boolean;
};

const Prices: React.FC<Props> = ({
  prices,
  activePrice,
  onPriceChange,
  isAvailable,
  pricePrefix,
  showExpiryDate,
  className,
  product,
  classNamePrice,
  classNamePriceCurrency,
  isNewPriceStyle,
}: Props) => {
  const onRadioChange = (price: Entity.Product.Price) => {
    if (price?.isExpirating && product) {
      gtm.onCheckExpirationProductInList(product);
    }
    onPriceChange && onPriceChange(price);
  };

  if (!prices.length || !isAvailable)
    return (
      <div className={styles.horizontalProductPreviewNotAvailable}>
        Нет в наличии
      </div>
    );

  return (
    <div className={cn([styles.horizontalProductPreviewPrices, className])}>
      {prices.map(price => {
        if (price.price === 0) return null;
        const checked = activePrice.priceTypeID === price.priceTypeID;

        return (
          <div
            key={price.priceTypeID}
            className={styles.horizontalProductPreviewRadio}
          >
            <Radio
              onChange={() => onRadioChange(price)}
              name="horizontal-prices"
              checked={checked}
              value={price.priceTypeID}
              label={
                <div className={styles.horizontalProductPreviewRadioLabel}>
                  <span
                    className={styles.horizontalProductPreviewRadioLabelText}
                  >
                    {showExpiryDate && price.dateExpired
                      ? `Годен до ${formatDate(price.dateExpired, "MM.YYYY")}`
                      : PRICES[price.priceTypeID]}
                  </span>
                  {!checked && (
                    <span
                      className={styles.horizontalProductPreviewRadioLabelPrice}
                    >
                      {formattedMoney(price.price)} ₽
                    </span>
                  )}
                </div>
              }
            />

            {activePrice.priceTypeID === price.priceTypeID && (
              <div className={styles.horizontalProductPreviewRadioValue}>
                <Price
                  className={classNamePrice}
                  classNamePrice={classNamePriceCurrency}
                  isNewPriceStyle={isNewPriceStyle}
                  price={price.price}
                  priceOld={price.priceOld}
                  discount={price.discount}
                  prefix={pricePrefix}
                  hasOnlyBookingPrices={
                    // в основном прайсе приходит priceTypeID === 1 заместо priceTypeID === 7
                    // на грумминге сказали что легаси не могут поправить
                    price.priceTypeID === "1" && product.hasOnlyBookingPrices
                  }
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Prices;
